module.exports = __webpack_public_path__ + "img/prioritas_vippack_dfod_dg.85fb3a84.png";